import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { useConfirm } from 'legacy/lut/components/shared/Confirm/useConfirm'
import { SIGNATURE_DROP_DIALOG } from 'legacy/lut/components/widgets/public/partner360/planning/components/powerServicesMembership'
import { useCallback } from 'react'

import { RenderWhen } from 'cng-common/components/renderWhen'
import { Translation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button'
import { useFinSobDropSignature } from 'partner360/hooks/finSob/useFinSobDropSignature'
import { IFinSobSidePanelSetting } from 'partner360/models/finSobSidePanel/IFinSobSidePanelSetting'

import { TRANSLATION_KEYS } from '../../translations'

import styles from './NotApplicableCategory.module.scss'

interface INotApplicableCategoryProps {
  selectedFinSobItem: IFinSobSidePanelSetting
  partnerId: string
  fYear: number
  programType: ProgramTypes
  isEditMode: boolean
  onChangeNotApplicableFlag: (item: IFinSobSidePanelSetting, isNeedDropCommitment?: boolean) => void
}

export const NotApplicableCategory = ({
  selectedFinSobItem,
  onChangeNotApplicableFlag,
  isEditMode,
}: INotApplicableCategoryProps) => {
  const { isNeedToShowSignDialog } = useFinSobDropSignature()
  const { confirm } = useConfirm()

  const switchOn = useCallback(async () => {
    if (isNeedToShowSignDialog) {
      const isNeedDropCommitment = await confirm(SIGNATURE_DROP_DIALOG)
      if (!isNeedDropCommitment) {
        return
      }
    }
    onChangeNotApplicableFlag(selectedFinSobItem, isNeedToShowSignDialog)
  }, [confirm, isNeedToShowSignDialog, onChangeNotApplicableFlag, selectedFinSobItem])

  return (
    <div className={styles.notApplicableItem}>
      <p>
        <Translation span text={`${selectedFinSobItem.Title}-editor`} />
        <Translation span text={TRANSLATION_KEYS.selectedNotApplicableCategory} />
      </p>
      <RenderWhen condition={isEditMode}>
        <Button onClick={switchOn} variant={'outlined'}>
          <Translation span text={TRANSLATION_KEYS.switchOn} />
        </Button>
      </RenderWhen>
    </div>
  )
}
